import { ReactNode } from "react";

import { AccessResult } from "utils/access";
import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import PrioritizeRunButton from "components/Run/elements/PrioritizeRunButton";

import { RunHistoryEntryType } from "../../types";
import styles from "./styles.module.css";

type WorkerPoolEntryWrapperProps = {
  workers: number;
  busyWorkers: number;
  drainedWorkers?: number;
  pendingRuns: number;
  label: ReactNode;
  runId: string;
  stackId: string;
  canPrioritize: AccessResult;
  isRunPrioritized: boolean;
  runQueryToRefetch: string;
};

export const WorkerPoolEntryWrapper = ({
  label,
  workers,
  pendingRuns,
  busyWorkers,
  drainedWorkers,
  canPrioritize,
  isRunPrioritized,
  runId,
  stackId,
  runQueryToRefetch,
}: WorkerPoolEntryWrapperProps) => {
  return (
    <HistoryEntryWrapper state={RunHistoryEntryType.WorkerPool} label={label}>
      <HistoryEntryNote>
        <dl className={styles.list}>
          <dt>All workers</dt>
          <dd>{workers}</dd>
          <dt>Busy</dt>
          <dd>{busyWorkers}</dd>
          {drainedWorkers !== undefined && (
            <>
              <dt>Drained</dt>
              <dd>{drainedWorkers}</dd>
            </>
          )}
          <dt>Pending runs</dt>
          <dd>{pendingRuns}</dd>
        </dl>
      </HistoryEntryNote>
      <PrioritizeRunButton
        runId={runId}
        canPrioritize={canPrioritize}
        stackId={stackId}
        isRunPrioritized={isRunPrioritized}
        runQueryToRefetch={runQueryToRefetch}
      />
    </HistoryEntryWrapper>
  );
};
